import { type App, inject } from 'vue'

const RESET_API_CLIENT = Symbol('resetApiClient')

export function provideResetApiClient(app: App, reset: () => void): void {
    app.provide(RESET_API_CLIENT, reset)
}

export function useResetApiClient(): { resetApiClient: () => void } {
    return { resetApiClient: inject(RESET_API_CLIENT) as () => void }
}
